import ContatoService from '../services/contato.service';

export const contato = {
    namespaced: true,
    state: {
        isLoading: false
    },
    actions: {
        async enviar({ commit }, contato) {
            try{
                commit('SET_IS_LOADING', true);
                const resp = await ContatoService.enviar(contato);
                commit('SET_IS_LOADING', false);
                return resp
            }catch(error){
            if(error.response){
                commit('SET_IS_LOADING', false);
                return error.response
            }else if (error.request) {
                commit('SET_IS_LOADING', false);
                return error.request
            } else {
                commit('SET_IS_LOADING', false);
                return error
            }
            }
        },
    },
    mutations: {
        SET_IS_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
    }
}